export const environment = {
	production: true,
  url: 'https://api.installer.kosaas-c1.com:3002'
};
